import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { OrganizationSchema, WebsiteSchema, WebPageSchema, FAQSchema } from '@/components/feature/SchemaOrg';
import { faqData } from '@/mocks/home';
import useSEO from '@/hooks/useSEO';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import ServiceSection from './components/ServiceSection';
import NewsFlash from './components/NewsFlash';
import MemberSection from './components/MemberSection';
import FAQSection from './components/FAQSection';

const breadcrumbs = [
  { name: '首页', url: 'https://taokep.cn/' },
];

export default function Home() {
  const location = useLocation();

  useSEO({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <OrganizationSchema />
      <WebsiteSchema />
      <WebPageSchema
        url="https://taokep.cn/"
        name="亚洲在线 · 亚洲数字生活一站式平台"
        description="覆盖娱乐、资讯、购物、社交等多元场景的综合数字服务平台"
        breadcrumbs={breadcrumbs}
      />
      <FAQSchema questions={faqData.map(f => ({ question: f.question, answer: f.answer }))} />

      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <ServiceSection />
        <NewsFlash />
        <MemberSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}